import { constants, mediaQueryStyles } from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs, sm } = breakpoints.BreakpointNames;

export const buttonCss = {
  padding: "8px",
  marginRight: "8px",
  marginBottom: "8px",

  [mediaQuery.downTo(xs)]: {
    marginBottom: 0,
  },
};

export const popOutContentsCss = {
  width: "480px",
  [mediaQuery.upTo(sm)]: {
    width: "100%",
  },
};

export const popOutContentsRootCss = {
  zIndex: 1,
};

export const popOutButtonItemCss = {
  height: "auto",
  textAlign: "left",
};
